export default __webpack_public_path__ + "components/page-header/static/surf-badge--light-4361017733415925489782774b02922f.svg";